/* eslint-disable no-shadow */
import { createTypes, completeTypes, withPostSuccess } from 'redux-recompose';

import { intl } from '~lib/intl';
import LocalStorageService from '~services/LocalStorageService';
import CoreService from '~services/Core/service';
import { setTenant } from '~config/api';

export const actions = createTypes(
  completeTypes(['GET_SETTINGS', 'GET_TENANT', 'SET_STORE_SELECTED'], ['SET_GCP_TENANT_ID']),
  '@@CORE'
);

const targets = {
  SETTINGS: 'settings',
  TENANT: 'tenant',
  STORE_SELECTED: 'storeSelected',
  GCP_TENANT_ID: 'gcpTenantId'
};

const DEFAULT_TENANT = 'justburger';

// Only multi-tenant hosts send it; existing tenants keep their REACT_APP_FIREBASE_ID_<TENANT>.
const GCP_TENANT_ID_HEADER = 'gcp-tenant-id';

const actionCreators = {
  getSettings: (onSettingsReady) => ({
    type: actions.GET_SETTINGS,
    service: CoreService.getSettings,
    target: targets.SETTINGS,
    injections: [
      withPostSuccess(async (_, response) => {
        await intl.init(response.data);
        if (onSettingsReady) {
          onSettingsReady();
        }
      })
    ]
  }),
  getTenant: (callback, onSettingsReady) => ({
    type: actions.GET_TENANT,
    service: CoreService.getTenant,
    target: targets.TENANT,
    successSelector: (response) => response.headers?.tenant || DEFAULT_TENANT,
    injections: [
      withPostSuccess((dispatch, response, state) => {
        dispatch({
          type: actions.SET_GCP_TENANT_ID,
          target: targets.GCP_TENANT_ID,
          payload: response.headers?.[GCP_TENANT_ID_HEADER] || ''
        });
        setTenant(state.core.tenant);
        dispatch(actionCreators.getSettings(onSettingsReady));
        if (callback) {
          callback();
        }
      })
    ]
  }),
  setStoreSelected: (id) => (dispatch, getState) => {
    const { adminUser } = getState().adminUser;
    const storeId = id !== undefined ? id : adminUser.storeIds[0];
    dispatch({
      type: actions.SET_STORE_SELECTED,
      target: targets.STORE_SELECTED,
      payload: storeId
    });
  },
  getLocalStorageData: () => (dispatch) => {
    const storeSelected = LocalStorageService.getStoreSelected();
    if (storeSelected) {
      dispatch(actionCreators.setStoreSelected(storeSelected));
    }
  }
};

export default actionCreators;
